import { BaseModel } from '../base-model';

export interface IGenericObject {
  IconUrl?: string;
  Id?: number;
  NameEN?: string;
  NameFR?: string;
  NameNL?: string;
  NameDE?: string;
  Name?: string;
  ParentId?: number;
  Expression?: string;
  CategoryTypeId?: number;
  // Status this substatus is scoped to. null = shared (selectable); a value means it
  // belongs to another application and is hidden from the substatus picker.
  OnlyForStatus?: number | null;
  // Status / SubStatus base type (EnumValues key). Status: 1 = Prospection, 2 = Active drive the
  // simplified prospection property entry; which base types mean Sold/Rented comes from the
  // PropertyStatus system configs (SWA-7539).
  BaseType?: number | null;
  // additional
  Checked?: boolean;
}
export class GenericObject extends BaseModel<IGenericObject> implements IGenericObject {
  IconUrl: string;
  Id: number;
  NameEN: string;
  NameFR: string;
  NameNL: string;
  NameDE?: string;
  Name: string;
  ParentId: number;
  Expression: string;

  // additional
  Checked?: boolean;
  /**
   *
   */
  constructor(option?: IGenericObject) {
    super(option);
  }
}